<template>
  <div class="ka-pc-modal-overlay" @click.self="$emit('close')">
    <div class="ka-pc-modal">
      <h2 class="ka-pc-modal-title">{{ t.filterButton }}</h2>

      <div class="ka-pc-modal-section">
        <span class="ka-pc-modal-label">{{ t.metalLabel }}</span>
        <label
          v-for="m in metals"
          :key="m.code"
          class="ka-pc-modal-check"
        >
          <input
            type="checkbox"
            :value="m.code"
            :checked="localMetals.indexOf(m.code) !== -1"
            @change="toggleMetal(m.code)"
          />
          <span class="ka-pc-check-box" :class="{ checked: localMetals.indexOf(m.code) !== -1 }"></span>
          <span class="ka-pc-check-text">{{ m.label }}</span>
        </label>
      </div>

      <div class="ka-pc-modal-section">
        <span class="ka-pc-modal-label">{{ t.unitLabel }}</span>
        <label
          v-for="u in units"
          :key="u.key"
          class="ka-pc-modal-check"
        >
          <input
            type="radio"
            name="unit"
            :value="u.key"
            :checked="localUnit === u.key"
            @change="localUnit = u.key"
          />
          <span class="ka-pc-check-box" :class="{ checked: localUnit === u.key }"></span>
          <span class="ka-pc-check-text">{{ u.label }}</span>
        </label>
      </div>

      <div class="ka-pc-modal-section">
        <span class="ka-pc-modal-label">{{ t.currencyLabel }}</span>
        <label
          v-for="c in currencyOptions"
          :key="c"
          class="ka-pc-modal-check"
        >
          <input
            type="radio"
            name="currency"
            :value="c"
            :checked="localCurrency === c.toLowerCase()"
            @change="localCurrency = c.toLowerCase()"
          />
          <span class="ka-pc-check-box" :class="{ checked: localCurrency === c.toLowerCase() }"></span>
          <span class="ka-pc-check-text">{{ c }}</span>
        </label>
      </div>

      <div class="ka-pc-modal-section">
        <span class="ka-pc-modal-label">{{ t.dateLabel }}</span>
        <div class="ka-pc-date-inputs">
          <input type="date" v-model="localDateFrom" class="ka-pc-date" />
          <span class="ka-pc-date-sep">&mdash;</span>
          <input type="date" v-model="localDateTo" class="ka-pc-date" />
        </div>
      </div>

      <div class="ka-pc-modal-actions">
        <button class="ka-pc-modal-btn ka-pc-modal-btn--back" @click="$emit('close')">
          {{ t.backButton }}
        </button>
        <button class="ka-pc-modal-btn ka-pc-modal-btn--save" @click="save">
          {{ t.saveButton }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterModal',
  props: {
    t: { type: Object, required: true },
    metals: { type: Array, required: true },
    units: { type: Array, required: true },
    currencyOptions: { type: Array, required: true },
    selectedMetals: { type: Array, required: true },
    selectedUnit: { type: String, required: true },
    selectedCurrency: { type: String, required: true },
    dateFrom: { type: String, required: true },
    dateTo: { type: String, required: true }
  },
  data() {
    return {
      localMetals: this.selectedMetals.slice(),
      localUnit: this.selectedUnit,
      localCurrency: this.selectedCurrency,
      localDateFrom: this.dateFrom,
      localDateTo: this.dateTo
    }
  },
  methods: {
    toggleMetal(code) {
      var idx = this.localMetals.indexOf(code);
      if (idx === -1) {
        this.localMetals.push(code);
      } else if (this.localMetals.length > 1) {
        this.localMetals.splice(idx, 1);
      }
    },
    save() {
      this.$emit('apply', {
        metals: this.localMetals.slice(),
        unit: this.localUnit,
        currency: this.localCurrency,
        dateFrom: this.localDateFrom,
        dateTo: this.localDateTo
      })
    }
  }
}
</script>
